export enum EAIPromptType {
  EmailGeneration = 'EMAIL_GENERATION',
  EmailVariation = 'EMAIL_VARIATION',
  LetterGeneration = 'LETTER_GENERATION',
  LetterVariation = 'LETTER_VARIATION',
}

export interface AIResponseDto {
  outputText: string;
}

export interface SubmitAIRequestDto {
  promptType: EAIPromptType;
  prompt: string;
  existingBodyText?: string; // Used for variation generation
}
